import React, { useEffect } from 'react';
import Image from 'next/image';
import useTranslation from 'next-translate/useTranslation';
import Skeleton from 'react-loading-skeleton';

import Button from '@/ui/Button/Button';
import ArrowLeftNew from '@/icons/ArrowLeftNew';
import ArrowRightNew from '@/icons/ArrowRightNew';

import styles from './styles.module.scss';

const AppBanner = ({ item }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = React.useState(item?.sections[0]);
  const [activeIndex, setActiveIndex] = React.useState(0);
  const [isImageLoaded, setIsImageLoaded] = React.useState(false);

  const nextHandler = () => {
    if (activeIndex !== item?.sections?.length - 1) {
      setIsImageLoaded(false);
      setActiveIndex(activeIndex + 1);
      setActiveTab(item?.sections[activeIndex + 1]);
    }
  };

  const prevHandler = () => {
    if (activeIndex !== 0) {
      setIsImageLoaded(false);
      setActiveIndex(activeIndex - 1);
      setActiveTab(item?.sections[activeIndex - 1]);
    }
  };

  useEffect(() => {
    setActiveTab(item?.sections[0]);
    setActiveIndex(0);
  }, [item]);

  const handleEventAction = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'bakcell_app',
    });
  };

  return (
    <section
      className={'section'}
      itemScope
      itemType='https://schema.org/Offer'
    >
      <div className={styles.container}>
        <div className={styles.top}>
          <div className={styles.logo}>
            <Image
              width={80}
              height={80}
              src='/assets/NewAppLogo.svg'
              alt='photo'
            />
          </div>
          <div className={styles.subTitle}>{item?.description}</div>
          <div
            className={styles.title}
            dangerouslySetInnerHTML={{ __html: item?.title }}
          />
          {item?.button_slug && item?.button_text && (
            <Button
              href={item?.button_slug}
              size='shortTrapezoid'
              variant='trapezoidRed'
              Component={'router'}
              onClick={handleEventAction}
              data-testid='app-download-btn'
            >
              {item?.button_text}
            </Button>
          )}
        </div>
        <div className={`${styles.bottom}`}>
          <div className={`${styles.bottomWrapper} wrapper`}>
            <div className={styles.hidden}></div>
            <div className={styles.imageWrapper}>
              {!!activeTab && (
                <>
                  {!isImageLoaded && (
                    <Skeleton
                      width={275}
                      height={560}
                      style={{ position: 'absolute', zIndex: 1 }}
                    />
                  )}

                  <Image
                    src={activeTab?.image}
                    alt='bakcell'
                    width={275}
                    height={560}
                    data-testid={'appbanner-image'}
                    onLoadingComplete={() => {
                      setIsImageLoaded(true);
                    }}
                    style={{
                      visibility: isImageLoaded ? 'visible' : 'hidden',
                    }}
                  />
                </>
              )}
            </div>
            <div className={styles.slider}>
              <span> {activeTab?.title}</span>
              <span>{activeTab?.description}</span>
              <div className={styles.buttons}>
                <div className={styles.buttonWrapper}>
                  <div
                    onClick={() => prevHandler()}
                    className={styles.previous}
                    data-testid={'appbanner-prev'}
                  >
                    <ArrowLeftNew />
                  </div>
                  <div
                    data-testid={'appbanner-next'}
                    onClick={() => nextHandler()}
                    className={styles.next}
                  >
                    <ArrowRightNew />
                  </div>
                </div>

                <div className={styles.query}>
                  {activeIndex + 1} of {item?.sections?.length}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppBanner;
